import React, { PureComponent } from 'react';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';
import {Typography} from '@material-ui/core'
const data = [
  { name: 'Em operação', value: 400 },
  { name: 'Inativos', value: 300 },
  { name: 'Em conexão', value: 90 },

];

const COLORS = ['#4db6ac', '#f00', '#1976d2', '#FF8042', '#8e24aa'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default class Example extends PureComponent {
    constructor(props){
      super(props)
    }

  render() {
    return (
      
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={80} height={80}>
          <Pie
            data={this.props.data && this.props.data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={80}
            fill="#8884d8"
   
            dataKey="value" 
            margin={{
              top: 10,
              right: 0,
              left: 0,
              bottom: 0,
            }}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      
    );
  }
}